module.exports = "/images/ny-life1-1.jpg";